import { render, staticRenderFns } from "./HoribaSamplesGroupDataTable.vue?vue&type=template&id=c45e9666"
import script from "./HoribaSamplesGroupDataTable.vue?vue&type=script&lang=js"
export * from "./HoribaSamplesGroupDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports